var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account-registration body-wrap boxed-container"},[_c('div',{staticClass:"container-herohire"},[_c('v-app',{attrs:{"dark":""}},[_c('Header'),_c('RegisterHeader'),_c('RegisterForm')],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }